export default __webpack_public_path__ + "static/media/granttechnique.e97f9b53.png";